import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useParams } from "react-router-dom";
import IconsGen from "../../../icons_generator/IconsGen"; 

const Users = ({ direction }) => {
  const [_] = useTranslation("global");
  const { slug, lang } = useParams();
  return (
    <div className="links-container d-flex flex-column">

      <NavLink
        className={`feature_link ${
          lang === "en" ? "feature_link_en" : ""
        } d-flex flex-row-reverse align-items-center gap-2 py-3`}
        dir={direction}
        to={`/${slug}/${lang}/panel/users`}
      >
        <IconsGen icon_name={"users"} />
        <p>{_("panel.users")}</p>
      </NavLink>
     
    </div>
  );
};

export default Users;
